import { BannerSlugEnum } from '@skippay/core/@types/bannerEnums';

export const BANNER_AVAILABLE_SLUGS = [
	BannerSlugEnum.HAS_ACTIVE_DEFERRED_PAYMENT,
	BannerSlugEnum.HAS_NO_ACTIVE_DEFERRED_PAYMENT,
	BannerSlugEnum.HAS_ACTIVE_PAY_IN_THREE,
	BannerSlugEnum.HAS_NO_ACTIVE_PAY_IN_THREE,
	BannerSlugEnum.HAS_ACTIVE_DEFERRED_AND_PAY_IN_THREE,
	BannerSlugEnum.HAS_NO_ACTIVE_DEFERRED_AND_PAY_IN_THREE,
	BannerSlugEnum.HAS_PREFERRED_BANK,
	BannerSlugEnum.HAS_NO_PREFERRED_BANK,
];
